




























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ConfirmPassword extends Vue {
  @Prop(String) 
  icon!: string;

  @Prop(String) 
  iconColor!: string;
}
